// use3DModels.js
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

/**
 * Loads a GLB model (fetch + parse via GLTFLoader),
 * then calls onLoadCallback(gltf, size).
 * 
 * @param {string} url - URL of the model to load
 * @param {Function} onLoadCallback - Callback function to execute when model is loaded
 */
export function loadModel(url, onLoadCallback) {
  console.log('Starting to load model from:', url);

  fetch(url)
    .then(response => {
      console.log('Fetch response status:', response.status);
      console.log('Content-Type:', response.headers.get('Content-Type'));
      return response.arrayBuffer();
    })
    .then(buffer => {
      console.log('Received data size:', buffer.byteLength);
      console.log('First few bytes:', new Uint8Array(buffer).slice(0, 20));

      // Now try loading with GLTFLoader.parse
      const loader = new GLTFLoader();
      loader.parse(
        buffer,
        '',
        (gltf) => {
          console.log('GLTF Parse succeeded!');
          const model = gltf.scene;
          const box = new THREE.Box3().setFromObject(model);
          const size = new THREE.Vector3();
          box.getSize(size);
          onLoadCallback(gltf, size);
        },
        (error) => {
          console.error('GLTFLoader parse error:', error);
        }
      );
    })
    .catch(error => {
      console.error('Fetch error:', error);

      // Fall back to the original loader method (direct URL)
      const loader = new GLTFLoader();
      loader.load(
        url,
        (gltf) => {
          console.log('Original loader succeeded');
          const model = gltf.scene;
          const box = new THREE.Box3().setFromObject(model);
          const size = new THREE.Vector3();
          box.getSize(size);
          onLoadCallback(gltf, size);
        },
        (progress) => {
          if (progress.total) {
            console.log(`Loading progress: ${((progress.loaded / progress.total) * 100).toFixed(2)}%`);
          } else {
            console.log('Loading...');
          }
        },
        (err) => {
          console.error('Error loading GLB model:', err);
        }
      );
    });
}

/**
 * Filters out extra animation tracks.
 * Only keeps Hips.position / .quaternion.
 * 
 * @param {THREE.AnimationClip} animation - The animation to filter
 * @returns {THREE.AnimationClip} - The filtered animation
 */
export function filterAnimation(animation) {
  animation.tracks = animation.tracks.filter((track) => {
    const name = track.name;
    return name.endsWith('Hips.position') || name.endsWith('.quaternion');
  });
  return animation;
}